import {
  ILoginUserData,
  ILoginResponse,
  ILoginByTokenResponse,
  ILoginByTokenData,
  ILoginByGoogleResponse,
  OldLoginInfo,
} from '../../dto/login-response.interface';

export class AuthModel {
  listmenu_active: string[] = [];
  result!: ILoginUserData | ILoginByTokenData | any;
  token!: string | undefined | any;
  contactID!: string | undefined;
  username!: string | undefined;
  old_login_info!: Partial<OldLoginInfo>;

  mapDataFromAPI(args: ILoginResponse) {
    this.token = args?.token;
    this.contactID = args?.contact_id;
    this.username = args?.username;
    this.result = args?.data;
    this.listmenu_active = args?.data?.menu?.map((id) => id.toString());
    this.old_login_info = args?.old_login_info ?? {};
    return this;
  }

  getOldAccessToken() {
    return this?.old_login_info?.token ?? '';
  }

  getOldLoginInfo() {
    return this?.old_login_info ?? {};
  }

  fromLoginByToken3thResponse(args: ILoginByTokenResponse) {
    this.token = args.token;
    this.contactID = args.contact_id;
    this.username = args.username;
    this.result = args.data;
    this.listmenu_active = [];
    return this;
  }

  fromLoginByGmailResponse(args: ILoginByGoogleResponse) {
    this.token = args.token;
    this.result = {
      avatar: args.userInfo.avatar,
      email: args.userInfo.email ?? '',
      ho_ten: args.userInfo.ho_ten ?? '',
    };
    this.listmenu_active = args.menu?.map((e) => e.toString());
    this.old_login_info = args?.old_login_info ?? {};
    return this;
  }
}
